import request from '../utils/http'
// 用户登录
export function index (query) {
  return request({
    url: '/login',
    method: 'POST',
    data: query
  })
}
// 图形验证码
export function captcha (query) {
  return request({
    url: '/captcha',
    method: 'GET',
    params: query
  })
}
// 登录注销
export function logout (query) {
  return request({
    url: '/logout',
    method: 'GET',
    params: query
  })
}
// 用户信息
export function userInfo (query) {
  return request({
    url: '/userInfo',
    method: 'GET',
    params: query
  })
}
// 获取权限
export function userPower (query) {
  return request({
    url: '/userPower',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js